import { PublicApiClient } from "../../apiClient/publicApiClient";
import { createStore } from "@stencil/store";
import { ServiceDocument } from "./document";
import dayjs from "dayjs";
import { oldReportTypes } from "./reportTypes";
export class Documents {
    constructor(config, tokenReady = () => { }) {
        /**
         * hide new report types
         * @deprecated will be removed in the future
         */
        this.hideNewReportTypes = false;
        this.store = createStore({
            documents: null,
            isLoading: true,
            error: null,
            minDate: null,
            maxDate: null,
            filters: {
                assignmentTypes: null,
                startDate: null,
                endDate: null
            }
        });
        this.apiClient = new PublicApiClient(config);
        this.apiClient.subscribeToTbdbToken(() => tokenReady());
        this.hideNewReportTypes = config.hideNewReportTypes || false;
    }
    getFilteredDocuments(documents = null) {
        if (!documents) {
            return null;
        }
        const { filters } = this.store.state;
        return documents.filter((doc) => {
            if (!filters.assignmentTypes || filters.assignmentTypes.includes(doc.mission.assignmentType)) {
                const startDate = filters.startDate ? new Date(filters.startDate) : null;
                const endDate = filters.endDate ? new Date(filters.endDate) : null;
                const createdAt = new Date(doc.createdAt);
                if (startDate && dayjs(createdAt).isBefore(startDate, "day")) {
                    return false;
                }
                if (endDate && dayjs(createdAt).isAfter(endDate, "day")) {
                    return false;
                }
                return true;
            }
            return false;
        });
    }
    async getDocumentsForMission(missionNumber) {
        await this.getDocuments(`/document/getdocumentsformission`, { missionNumber });
    }
    async getDocumentsForMachine(machineNumber) {
        await this.getDocuments(`/document/getdocumentsformachine`, { machineNumber });
        try {
            const linkableMissions = await this.getLinkableMissions();
            this.addLinksToDocuments(linkableMissions);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching linkable missions:", error);
        }
    }
    addLinksToDocuments(linkableMissions) {
        if (linkableMissions.length === 0) {
            return;
        }
        const linkableMissionNumbers = linkableMissions.map((mission) => mission.missionNumber);
        const { documents } = this.store.state;
        documents === null || documents === void 0 ? void 0 : documents.forEach((doc) => {
            if (linkableMissionNumbers.includes(doc.mission.sisMissionId)) {
                doc.makeMissionLinkable();
            }
        });
    }
    async getDocuments(url, body) {
        try {
            const response = await this.apiClient.request(url, { body });
            this.store.state.documents = response
                .filter((doc) => this.preFilterDocuments(doc))
                .map((docData) => new ServiceDocument(docData, this.apiClient));
            this.calculateMinMaxDates();
            this.store.state.error = null;
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error fetching documents:", error);
            this.store.state.error = "An error occurred while fetching documents.";
        }
        finally {
            this.store.state.isLoading = false;
        }
    }
    preFilterDocuments(docData) {
        var _a;
        if (this.hideNewReportTypes) {
            return oldReportTypes.includes((_a = docData === null || docData === void 0 ? void 0 : docData.mission) === null || _a === void 0 ? void 0 : _a.assignmentType);
        }
        return true;
    }
    // not all missions are available on myTrumpf to link to, thats why we need to fetch available missions
    async getLinkableMissions() {
        return this.apiClient.request("/appointment/findmissionitems", {});
    }
    calculateMinMaxDates() {
        const { documents } = this.store.state;
        if (!documents || documents.length === 0) {
            this.store.state.minDate = null;
            this.store.state.maxDate = null;
            return;
        }
        const dates = documents.map((doc) => new Date(doc.createdAt).getTime());
        this.store.state.minDate = new Date(Math.min(...dates)).toISOString().split("T")[0];
        this.store.state.maxDate = new Date(Math.max(...dates)).toISOString().split("T")[0];
    }
}
//# sourceMappingURL=documents.js.map
